import { Platform } from 'react-native';
import * as Clipboard from 'expo-clipboard';

export const copyToClipboard = async (text: string) => {
  if (Platform.OS === 'web') {
    navigator.clipboard.writeText(text);
  } else {
    await Clipboard.setStringAsync(text);
  }
};
